import { Component, Input, OnInit } from '@angular/core';
import { Author } from 'src/app/api/models';

@Component({
    selector: 'app-item-author',
    templateUrl: './item-author.component.html',
    styleUrls: ['./item-author.component.scss'],
    standalone: false
})
export class ItemAuthorComponent implements OnInit {
  @Input() authors: Author[] = [];
  authorString: string = '';
  authorTooltip: string = '';

  constructor() { }

  ngOnInit(): void {
    this.authorString = this.authors.map(author => {
      let authorName = ''
      if (author.nickname) {
        authorName = author.nickname;
      } else if (author.firstname && author.lastname) {
        authorName = `${author.firstname} ${author.lastname}`;
      } else if (author.lastname) {
        authorName = author.lastname;
      } else {
        authorName = 'Chybí jméno autora';
      }
      return authorName;
     }).join(', ');
  }


}
